var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerPlaceholer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(-112 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7374",
    "data-name": "Rectangle 7374",
    transform: "translate(112 98)",
    fill: "#fff",
    stroke: "#66338f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 127,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M64.008,19.144A21.169,21.169,0,1,1,42.842,40.314,21.17,21.17,0,0,1,64.008,19.144Zm-.014,92.13A46.968,46.968,0,0,1,33.408,100a9.018,9.018,0,0,1-3.165-6.86A21.348,21.348,0,0,1,51.694,71.795H76.329A21.319,21.319,0,0,1,97.748,93.136a9,9,0,0,1-3.165,6.857A46.952,46.952,0,0,1,63.994,111.274Z",
    transform: "translate(111.998 97.998)",
    fill: "#66338f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPlaceholer);
export default __webpack_public_path__ + "static/media/customer_placeholer.e3934f1f30f3f747a17e62ff5a91b80e.svg";
export { ForwardRef as ReactComponent };